var e = Symbol("cache-parser");
function a(e) {
  return ("string" == typeof e || "number" == typeof e) && (e = Number(e)) >= 0 && e < Infinity;
}
function r(e) {
  return !0 === e || "number" == typeof e || "string" == typeof e && "false" !== e;
}
var t = Number;
function s(s) {
  var n = Object.defineProperty({}, e, {
    enumerable: !1,
    value: 1
  });
  if (!s || "string" != typeof s) return n;
  var i = function (e) {
      var a = {},
        r = e.toLowerCase().replace(/\s+/g, "").split(",");
      for (var t in r) {
        var s,
          n = r[t].split("=", 2);
        a[n[0]] = null == (s = n[1]) || s;
      }
      return a;
    }(s),
    u = i["max-age"],
    l = i["max-stale"],
    o = i["min-fresh"],
    m = i["s-maxage"],
    p = i["stale-if-error"],
    h = i["stale-while-revalidate"];
  return r(i.immutable) && (n.immutable = !0), a(u) && (n.maxAge = t(u)), a(l) && (n.maxStale = t(l)), a(o) && (n.minFresh = t(o)), r(i["must-revalidate"]) && (n.mustRevalidate = !0), r(i["must-understand"]) && (n.mustUnderstand = !0), r(i["no-cache"]) && (n.noCache = !0), r(i["no-store"]) && (n.noStore = !0), r(i["no-transform"]) && (n.noTransform = !0), r(i["only-if-cached"]) && (n.onlyIfCached = !0), r(i.private) && (n.private = !0), r(i["proxy-revalidate"]) && (n.proxyRevalidate = !0), r(i.public) && (n.public = !0), a(m) && (n.sMaxAge = t(m)), a(p) && (n.staleIfError = t(p)), a(h) && (n.staleWhileRevalidate = t(h)), n;
}
function n(e) {
  if (!e || "object" != typeof e) return [];
  var t = [];
  return r(e.immutable) && t.push("immutable"), a(e.maxAge) && t.push("max-age=" + e.maxAge), a(e.maxStale) && t.push("max-stale=" + e.maxStale), a(e.minFresh) && t.push("min-fresh=" + e.minFresh), r(e.mustRevalidate) && t.push("must-revalidate"), r(e.mustUnderstand) && t.push("must-understand"), r(e.noCache) && t.push("no-cache"), r(e.noStore) && t.push("no-store"), r(e.noTransform) && t.push("no-transform"), r(e.onlyIfCached) && t.push("only-if-cached"), r(e.private) && t.push("private"), r(e.proxyRevalidate) && t.push("proxy-revalidate"), r(e.public) && t.push("public"), a(e.sMaxAge) && t.push("s-maxage=" + e.sMaxAge), a(e.staleIfError) && t.push("stale-if-error=" + e.staleIfError), a(e.staleWhileRevalidate) && t.push("stale-while-revalidate=" + e.staleWhileRevalidate), t;
}
function i(a) {
  return !!a && !!a[e];
}
export { i as isCacheControl, s as parse, n as tokenize };